import { Progress } from '@chakra-ui/react';
import { useWizardProgressBar } from './hooks/useWizardProgressBar';

export const WizardProgress: React.FC = (): JSX.Element => {
  const progressValue = useWizardProgressBar();

  return <Progress bg="brand.gray" value={progressValue} />;
};
